import { defineMessages } from 'react-intl';

export default defineMessages({
  newEmailLabel: {
    id: 'features.changeEmail.newEmailLabel',
    defaultMessage: 'Inserisci nuova email',
    description: 'Label shown above the new email input field',
  },
  newEmailPlaceholder: {
    id: 'features.changeEmail.newEmailPlaceholder',
    defaultMessage: 'Es. nome.cognome@email.com',
    description: 'Placeholder of the new email input field',
  },
  confirmNewEmailLabel: {
    id: 'features.changeEmail.confirmNewEmailLabel',
    defaultMessage: 'Conferma nuova email',
    description: 'Label shown above the confirmation new email input field',
  },
  confirmNewEmailPlaceholder: {
    id: 'features.changeEmail.confirmNewEmailPlaceholder',
    defaultMessage: 'Es. nome.cognome@email.com',
    description: 'Placeholder of the confirmation new email input field',
  },
  changeEmailGoOnButton: {
    id: 'features.changeEmail.changeEmailGoOnButton',
    defaultMessage: 'Avanti',
    description: 'Label of the change email button',
  },
  newEmailLabelDisabled: {
    id: 'features.changeEmail.newEmailLabelDisabled',
    defaultMessage: 'Nuova email',
    description: 'Label shown above the new email input field disabled',
  },
  labelChangeEmailVerificationCodeEmail: {
    id: 'features.changeEmail.labelChangeEmailVerificationCodeEmail',
    defaultMessage:
      'Inserisci il codice che è stato inviato all’indirizzo email scelto.',
    description: 'Label shown above the verification input field',
  },
  placeholderChangeEmailVerificationCodeEmail: {
    id: 'features.changeEmail.placeholderChangeEmailVerificationCodeEmail',
    defaultMessage: 'Inserisci il tuo codice di verifica email ',
    description: 'Placeholder of the verification code input field',
  },
  labelChangeEmailVerificationCodePhoneNumber: {
    id: 'features.changeEmail.labelChangeEmailVerificationCodePhoneNumber',
    defaultMessage:
      'Inserisci il codice che è stato inviato al numero di cellulare',
    description: 'Placeholder of the verification code input field',
  },
  placeholderChangeEmailVerificationCodePhoneNumber: {
    id: 'features.changeEmail.placeholderChangeEmailVerificationCodePhoneNumber',
    defaultMessage: 'Inserisci il tuo codice di verifica numero di cellulare',
    description: 'Placeholder of the verification code input field',
  },
  desclaimerVerificationOtp: {
    id: 'features.changeEmail.desclaimerVerificationOtp',
    defaultMessage:
      'Inserisci i codici che sono stati inviati all’indirizzo email e al numero di cellulare. In caso di mancata ricezione dell’email verifica nella cartella spam. Se non hai ricevuto l’email o l’SMS, è possibile contattare telefonicamente il servizio di assistenza dedicato, al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00.(Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'text of disclaimer',
  },
  disclaimerCountDown: {
    id: 'features.changeEmail.disclaimerCountDown',
    defaultMessage: 'I codici scadranno tra: ',
    description: 'text of disclaimer',
  },
  titleSummaryChangeEmail: {
    id: 'features.changeEmail.titleSummaryChangeEmail',
    defaultMessage: 'Nuova email',
    description: 'Title of step 3 of change email',
  },
  disclaimerSummaryChangeEmail: {
    id: 'features.changeEmail.disclaimerSummaryChangeEmail',
    defaultMessage:
      'Si avvisa che dopo la conferma dell’email inserita, sarà necessario firmare digitalmente la richiesta per rendere effettiva la modifica',
    description: 'Disclaimer of step 3 of change email',
  },
  disclaimerEmailSigned: {
    id: 'features.changeEmail.disclaimerEmailSigned',
    defaultMessage:
      'Una volta firmato il documento di modifica, non sarà possibile effettuare ulteriori richieste nei 5 giorni successivi',
    description: 'Disclaimer of step 3 of change email',
  },
  changeEmailConfirmButton: {
    id: 'features.changeEmail.changeEmailConfirmButton',
    defaultMessage: 'Conferma',
    description: 'Label of the confirmation change email button',
  },
  errorInvalidEmailFormat: {
    id: 'features.changeEmail.errorInvalidEmailFormat',
    defaultMessage: 'Controlla che l’indirizzo e-mail inserito sia corretto.',
    description: 'Error invalid email format ',
  },
  errorEmailsNotMatching: {
    id: 'features.changeEmail.errorEmailsNotMatching',
    defaultMessage: 'Attenzione, i dati inseriti non corrispondono',
    description: 'Error emails not matching',
  },
  errorExpiredDocument: {
    id: 'features.changeEmail.errorExpiredDocument',
    defaultMessage:
      'Attenzione! Impossibile procedere con la modifica delle credenziali per documento di identità scaduto.',
    description: 'Error document expired',
  },
  errorEmailNotUsable: {
    id: 'features.changeEmail.errorEmailNotUsable',
    defaultMessage:
      'L’indirizzo email risulta già associato ad un altro contratto MyAzimut. Si prega di inserire un altro indirizzo email',
    description: 'Error email already associated',
  },
  errorWrongCode: {
    id: 'features.changeEmail.errorWrongCode',
    defaultMessage:
      'I codici inseriti per la verifica email e cellulare non sono corretti. Riprova. Tentativi rimasti email: {attemptsEmail} Tentativi rimasti cellulare: {attemptsPhoneNumber}',
    description: 'Error wrong code verification email ',
  },
  errorTooManyAttemptsTitle: {
    id: 'features.changeEmail.errorTooManyAttemptsTitle',
    defaultMessage: 'Attenzione!',
    description:
      'Title error too many attempts for dialog email verification page ',
  },
  errorTooManyAttemptsMessage: {
    id: 'features.changeEmail.errorTooManyAttempts',
    defaultMessage:
      'Hai raggiunto il limite di tentativi disponibili per verificare l’email inserita. Inserisci nuovamente l’indirizzo email per procedere con la verifica.',
    description:
      'Error message too many attempts for dialog email verification page ',
  },
  errorTooManyAttemptsButtonLabel: {
    id: 'features.changeEmail.errorTooManyAttemptsButtonLabel',
    defaultMessage: 'Ok',
    description:
      'Label button error too many attempts for dialog email verification page ',
  },
  errorEmailNotEditable: {
    id: 'features.changeEmail.errorEmailNotEditable',
    defaultMessage:
      'Non è possibile procedere con la richiesta di modifica dell’indirizzo email, perché ci sono dei documenti da firmare.',
    description: 'Error message email not editable ',
  },
  errorEmailNotEditableButtonLabel: {
    id: 'features.changeEmail.errorEmailNotEditableButtonLabel',
    defaultMessage: 'Ok',
    description: 'Label button error email not editable',
  },
  errorEmailNotEditableAfterFirstFiveDays: {
    id: 'features.changeEmail.errorEmailNotEditableAfterFirstFiveDays',
    defaultMessage:
      'Non è possibile modificare l’indirizzo email, in quanto è già stato effettuato nei 5 giorni precedenti.',
    description:
      'Error message email not editable the first five days after last updating',
  },
  errorEmailNotEditablePhoneNumberVerification: {
    id: 'features.changeEmail.errorEmailNotEditablePhoneNumberVerification',
    defaultMessage:
      'Non è possibile modificare l’indirizzo email, in quanto è in corso la modifica del numero di cellulare.',
    description:
      'Error message email not editable because the phone number editing is not verified yet',
  },

  expiredOtpCodesError: {
    id: 'features.changeEmail.expiredOtpCodesError',
    defaultMessage:
      'I codici OTP sono scaduti. Si prega di tornare indietro e inserire nuovamente l’indirizzo email',
    description: '',
  },
  wrongOtpCodePhoneError: {
    id: 'features.changePhoneNumber.wrongOtpCodePhoneError',
    defaultMessage:
      'Il codice inserito per la verifica cellulare non è corretto. Riprova. Tentativi rimasti email: {attemptsEmail} Tentativi rimasti cellulare: {attemptsPhoneNumber}',
    description: '',
  },

  wrongOtpCodeEmailError: {
    id: 'features.changePhoneNumber.wrongOtpCodeEmailError',
    defaultMessage:
      'Il codice inserito per la verifica email non è corretto. Riprova. Tentativi rimasti email: {attemptsEmail} Tentativi rimasti cellulare: {attemptsPhoneNumber}',
    description: '',
  },

  maximumAttemptsAchievedError: {
    id: 'features.changePhoneNumber.maximumAttemptsAchievedError',
    defaultMessage:
      'Hai raggiunto il limite di tentativi disponibili per verificare l’email inserita. Inserisci nuovamente l’indirizzo email per procedere con la verifica',
    description: '',
  },
});
